var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-submit"},[_c('b-button',{style:(_vm.btnStyles),attrs:{"size":"lg","type":_vm.btnType}},[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }